const ANALYTICS_PROGRAM_SELECTION_STORAGE_KEY_PREFIX = 'portals:analytics-program-selection'
const LEGACY_ANALYTICS_PROGRAM_SELECTION_STORAGE_KEY_PREFIX = 'client-analytics-programs'

export function getAnalyticsProgramSelectionStorageKey(
  memberId: string,
  contextKey: string,
): string {
  return `${ANALYTICS_PROGRAM_SELECTION_STORAGE_KEY_PREFIX}:${memberId}:${contextKey}`
}

function removeLocalStorageKeysByPrefix(prefix: string): void {
  const keysToRemove: string[] = []
  for (let index = 0; index < window.localStorage.length; index += 1) {
    const key = window.localStorage.key(index)
    if (key?.startsWith(prefix)) {
      keysToRemove.push(key)
    }
  }
  keysToRemove.forEach((key) => {
    window.localStorage.removeItem(key)
  })
}

export function loadAnalyticsProgramSelection(memberId: string, contextKey: string): string | null {
  if (typeof window === 'undefined' || !memberId) return null

  try {
    return window.localStorage.getItem(getAnalyticsProgramSelectionStorageKey(memberId, contextKey))
  } catch {
    return null
  }
}

export function saveAnalyticsProgramSelection(
  memberId: string,
  contextKey: string,
  partnerIds: readonly string[],
): void {
  if (typeof window === 'undefined' || !memberId) return

  try {
    window.localStorage.setItem(
      getAnalyticsProgramSelectionStorageKey(memberId, contextKey),
      JSON.stringify(partnerIds),
    )
  } catch {
    // A blocked or full browser store must not prevent selecting programs for this visit.
  }
}

export function clearAllAnalyticsProgramSelection(): void {
  if (typeof window === 'undefined') return

  try {
    removeLocalStorageKeysByPrefix(`${ANALYTICS_PROGRAM_SELECTION_STORAGE_KEY_PREFIX}:`)
    removeLocalStorageKeysByPrefix(`${LEGACY_ANALYTICS_PROGRAM_SELECTION_STORAGE_KEY_PREFIX}:`)
  } catch {
    // Browser storage can be unavailable. Logout and session expiry still continue.
  }
}
